<template>
  <v-select :items="items" v-model="selected" label="Date Format" :outlined="outlined"></v-select>
</template>

<script>
var moment = require("moment");
export default {
  name: "AgentEditorConfigurationDateFormat",

  props: {
    currentFormat: {
      type: String
    },
    outlined: {
      type: Boolean,
      default: () => false
    }
  },

  data() {
    return {
      items: [
        { text: moment(new Date()).format("DD-MM-YYYY"), value: "DD-MM-YYYY" },
        { text: moment(new Date()).format("DD/MM/YYYY"), value: "DD/MM/YYYY" },
        { text: moment(new Date()).format("MM-DD-YYYY"), value: "MM-DD-YYYY" },
        { text: moment(new Date()).format("MM/DD/YYYY"), value: "MM/DD/YYYY" }
      ],
      selected: {
        text: moment(new Date()).format(this.currentFormat),
        value: this.currentFormat
      }
    };
  },

  watch: {
    currentFormat(value) {
      this.selected = { text: moment(new Date()).format(value), value: value };
    },
    selected(selectedFormat) {
      if (typeof selectedFormat == "object") {
        this.$emit("onSelect", selectedFormat.value);
      } else {
        this.$emit("onSelect", selectedFormat);
      }
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/gt/agents/AgentEditorConfigurationDateFormat.vue